import React from "react";
import PropTypes from "prop-types";

import { DragDropContext, Droppable } from "react-beautiful-dnd";

import DraggableItem from "./DraggableItem";

const DragAndDropContainer = ({
  items,
  onDragEnd,
  removeItem,
  onEmployeeChange,
  employeeData,
  isNightMode,
  disabled
}) => (
  <DragDropContext onDragEnd={onDragEnd}>
    <Droppable droppableId="droppable">
      {(droppableProvided) => (
        <div
          {...droppableProvided.droppableProps}
          ref={droppableProvided.innerRef}
          style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
        >
          {items.map((item, index) => (
            <DraggableItem
              key={item.id}
              item={item}
              items={items}
              count={items.length}
              index={index}
              removeItem={removeItem}
              onChange={onEmployeeChange}
              employeeData={employeeData}
              isNightMode={isNightMode}
              disabled={disabled}
            />
          ))}
          {droppableProvided.placeholder}
        </div>
      )}
    </Droppable>
  </DragDropContext>
);

DragAndDropContainer.propTypes = {
  items: PropTypes.array,
  onDragEnd: PropTypes.func,
  removeItem: PropTypes.func,
  onEmployeeChange: PropTypes.func,
  employeeData: PropTypes.array,
  isNightMode: PropTypes.bool,
  disabled: PropTypes.bool
};

export default DragAndDropContainer;
